// WHICH LINE `/checkout` SAYS ABOUT WHERE CREDITS WORK — AND WHERE IT SAYS NONE (B6b; R189, Tyler's decision 3,
// 2026-10-08: "the old 'credits bought in our iPhone app work only in the app' line stops showing where it is no longer
// true"; and launch day, 2026-10-14, option B: "B.. im going to keep going").
//
// Three approved sentences, and no fourth:
//   - WEB-COPY-1 item 8, `checkout.separateBalances` (B6b's words, 2026-10-09; heldCopy.ts `B6B_SENTENCES_APPROVED`): "At
//     this time, credits bought in our iPhone app work only in the app, and credits bought on app.proppeal.com work only
//     on the website. They don't move between the two."
//   - option B's two (heldCopy.ts `CHECKOUT_CREDITS_APPROVED`), one per kind of account:
//       `checkout.credits.appleLinked`: "Your credits are saved to your account and also work in our iPhone app when you
//         sign in there with Apple."
//       `checkout.credits.noApple`: "Your credits are saved to your account. To use them in our iPhone app too, add Apple
//         under Account, then sign in there with Apple." (The Account page offers a password account "Add Apple", G10.)
// Until 2026-10-14 every signed-in account was told ACC-3b's K1, `account.k.creditsBothPlaces` ("Your credits work on
// app.proppeal.com, and in our iPhone app when you sign in there with Apple to this same account, wherever you bought
// them."). Tyler found it confusing on production, and for an email-and-password account it was wrong: that account has
// no Apple to sign in with. K1 stays in heldCopy.ts as the record and renders nowhere.
//
// THE FACT THEY STATE IS WHOSE BALANCE THIS IS, NOT WHICH SWITCH IS ON. A balance is the uid's (v1's `users/{uid}`), on
// both clients, whatever WEB_ACCOUNTS_ENABLED says. The app signs in only with Apple (R189 answer 2: its email sign-in comes
// after the website), so a uid the app can reach is one with Apple linked:
//   - a look-around (anonymous): its uid exists only in this browser — item 8 is TRUE;
//   - a password account without Apple: the app cannot sign in to it — item 8 is TRUE;
//   - an account with Apple linked: the app signs in to the same uid — item 8 is FALSE.
//
// So, state by state (the switch as this page heard it, `useWebAccounts()`):
//   ON, an account with Apple linked (an Apple account, or a password account that added Apple) → `appleLinked`.
//   ON, a password account without Apple → `noApple`: saved to the account, and the way to the app is to add Apple.
//   ON, nobody signed in → NOTHING. Buying needs an account with the switch on, and an Apple one shares the app's balance,
//     so item 8 would be false. (`CheckoutGate` sends a signed-out visitor to `/account` before this page renders, so
//     this arm is the rule stated whole, not a path the page takes today.)
//   OFF, no Apple sign-in (a look-around, the only buyer today's site has, or a password account left from a time the
//     switch was on) → item 8. True.
//   OFF, an Apple sign-in left from a time the switch was on (the R107 undo) → NOTHING. That uid is the app's, so item 8
//     is false, and the switch-off site says none of the one-account sentences. No approved words fit.
//   NOT YET HEARD (null) → NOTHING: which sentence is true depends on the switch. Until 2026-10-08 the page said item 8
//     here, to everyone — so a visitor whose switch was about to answer "on" could read it for a moment.
// `test/checkoutBalanceLine.test.tsx` holds every row of this table.

import { signedIn, type WebAccounts } from "../app/accounts";
import type { CheckoutCreditsId } from "../components/heldCopy";
import type { AuthSession } from "../services";

export type BalanceLineId = CheckoutCreditsId | "checkout.separateBalances";

export function balanceLine(
  webAccounts: WebAccounts,
  auth: Pick<AuthSession, "provider" | "linkedProviders">,
): BalanceLineId | null {
  if (webAccounts === true) {
    if (!signedIn(auth)) return null;
    return auth.linkedProviders.includes("apple") ? "checkout.credits.appleLinked" : "checkout.credits.noApple";
  }
  if (webAccounts === false) return auth.linkedProviders.includes("apple") ? null : "checkout.separateBalances";
  return null;
}
